import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, api } from '../App';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found');
          navigate('/');
          return;
        }
        
        const sessionId = sessionIdMatch[1];
        const role = localStorage.getItem('pendingRole') || 'researcher';
        
        // Exchange session_id for session token
        const response = await api.post('/auth/session', {
          session_id: sessionId,
          role: role
        });
        
        if (response.data.success && response.data.user) {
          // Save session token to localStorage for Authorization header
          if (response.data.session_token) {
            localStorage.setItem('session_token', response.data.session_token);
          }
          setUser(response.data.user);
          localStorage.removeItem('pendingRole');
          
          // Redirect based on role
          const redirectPath = response.data.user.role === 'researcher'
            ? '/researcher/dashboard'
            : '/client/dashboard';
          
          navigate(redirectPath, { replace: true });
        } else {
          throw new Error('Auth failed');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };
    
    processAuth();
  }, [navigate, setUser]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-neutral-800 mx-auto mb-4"></div>
        <p className="text-neutral-600">Completing sign in...</p>
      </div>
    </div>
  );
}
